import React from 'react';
import TakisNav from "../components/TakisNav"
import TakisHero from "../components/TakisHero"
import TakisProductDetailHero from "../components/TakisProductDetailHero"
import navData from "../data/components/global-nav.json"
import productsData from "../data/components/products-grid.json"
import freeTextData from "../data/components/free-text.json"
import recipesListData from "../data/components/recipes-list.json"
import homeHeroData from "../data/components/homepage-hero.json"
import socialData from "../data/components/social.json"
import productDetailHero from "../data/components/product-detail-hero.json"
import recipeDetailComponents from "../data/components/recipeDetailComponents.json";
import TakisButton from '../components/TakisButton';
import TakisFreeText from '../components/TakisFreeText';
import TakisRecipeList from '../components/TakisRecipeList';
import TakisGrid from '../components/TakisGrid';
import TakisSocial from '../components/TakisSocial';
import TakisLink from '../components/TakisLink';
import TakisMediaComponent from '../components/TakisMediaComponent';
import TakisSimpleText from '../components/TakisSimpleText';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { TakisSvg } from '../components/TakisSvgs';


const Components = () => {

  const useStyles = makeStyles(theme => ({
    showcase: {
      width: 80,
      height: 80
    },
    icon_showcase:{
      width: 35,
      height: 35,
      color: theme.palette.purple
    },
    white:{
      backgroundColor: theme.palette.white
    },
    black:{
      backgroundColor: theme.palette.black
    },
    yellow:{
      backgroundColor: theme.palette.yellow
    },
    purple:{
      backgroundColor: theme.palette.purple
    },
    darkPurple:{
      backgroundColor: theme.palette.darkPurple
    }
  }));


  const classes = useStyles();

  return (
    <>
      <br/><br/><br/><br/>
      <h1>Components</h1>
      <br /><br /><br />

      <TakisSocial data={socialData.social}></TakisSocial>

      <h3>Nav</h3>
      <TakisNav data={navData.global_nav}></TakisNav>
      <br /><br /><br />

      <h3>Heros</h3>
      <TakisHero data={homeHeroData.hero}></TakisHero>
      <br /><br /><br />

      <br /><br />
      <TakisProductDetailHero
        heroImageDesktopSrc={productDetailHero.hero.heroImageDesktopSrc}
        heroImageTabletSrc={productDetailHero.hero.heroImageTabletSrc}
        heroImageMobileSrc={productDetailHero.hero.heroImageMobileSrc}
        heroImageTopBackgroundDesktopSrc={productDetailHero.hero.heroImageTopBackgroundDesktopSrc}
        heroImageTopBackgroundTabletSrc={productDetailHero.hero.heroImageTopBackgroundTabletSrc}
        heroImageTopBackgroundMobileSrc={productDetailHero.hero.heroImageTopBackgroundMobileSrc}
        heroImageBottomBackgroundSrc={productDetailHero.hero.heroImageBottomBackgroundSrc}
        heroImageAlt={productDetailHero.hero.heroImageAlt}
        title={productDetailHero.hero.title}
        heroParagraph={productDetailHero.hero.heroParagraph}
        firstCta= {productDetailHero.hero.firstCta}
        secondCta={productDetailHero.hero.secondCta}
      />
      <br /><br /><br />

      <h3>Buttons</h3>
      <TakisButton title="CTA Text" alt="CTA Alt Text" href="#" ariaLabel="CTA Aria Label"/>
      <TakisButton title="CTA Text" alt="CTA Alt Text" href="#" ariaLabel="CTA Aria Label" color="whiteButton" orientation="tiltedLeft"/>
      <TakisButton title="CTA Text" alt="CTA Alt Text" href="#" ariaLabel="CTA Aria Label" color="purpleButton" />
      <TakisButton title="CTA Text" alt="CTA Alt Text" href="#" ariaLabel="CTA Aria Label" color="purpleWhiteButton" orientation="tiltedLeftHover"  />
      <br /><br /><br />


      <h3>Links</h3>
      <TakisLink href="#" target="" title="BARCEL USA" type="CtaLink"/>
      <TakisLink href="#" target="" title="Terms & Conditions"/>
      <br /><br /><br />


      <h3>Typography</h3>
      <h1>Heading 1</h1>
      <h2>Heading 2</h2>
      <h3>Heading 3</h3>
      <h4>Heading 4</h4>
      <h5>Heading 5</h5>
      <h6>Heading 6</h6>
      <big>Big Font</big>
      <p>Paragraph</p>
      <small>Small Font</small>
      <br /><br /><br />


      <h3>Pallete</h3>
      <small>Theme.palette.white</small>
      <Paper className={`${classes.showcase} ${classes.white}`} elevation={5} />
      <small>Theme.palette.black</small>
      <Paper className={`${classes.showcase} ${classes.black}`} elevation={5} />
      <small>Theme.palette.yellow</small>
      <Paper className={`${classes.showcase} ${classes.yellow}`} elevation={5} />
      <small>Theme.palette.purple</small>
      <Paper className={`${classes.showcase} ${classes.purple}`} elevation={5} />
      <small>Theme.palette.darkPurple</small>
      <Paper className={`${classes.showcase} ${classes.darkPurple}`} elevation={5} />

      <br /><br /><br />


      <h3>Icons</h3>

      <TakisSvg icon="downArrow" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="leftArrow" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="rightArrow" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="upArrow" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="facebook" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="twitter" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="instagram" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="mail" svg_class={classes.icon_showcase} viewbox="0 0 32 24"/>
      <TakisSvg icon="circleCheck" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="check" svg_class={classes.icon_showcase} viewbox="0 0 32 24"/>
      <TakisSvg icon="comment" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="x" svg_class={classes.icon_showcase} viewbox="0 0 24 24"/>
      <TakisSvg icon="circleX" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="user" svg_class={classes.icon_showcase} viewbox="0 0 32 32"/>
      <TakisSvg icon="caretUp" svg_class={classes.icon_showcase} viewbox="0 0 32 18"/>
      <TakisSvg icon="caretDown" svg_class={classes.icon_showcase} viewbox="0 0 32 18"/>
      <TakisSvg icon="youtube" svg_class={classes.icon_showcase} viewbox="0 0 40 40"/>
      <TakisSvg icon="tiktok" svg_class={classes.icon_showcase} viewbox="0 0 40 40"/>

      <br /><br /><br />


      <h3>Modules</h3>
      <TakisFreeText
        title={freeTextData.free_text_one_column.title}
        titleColor={freeTextData.free_text_one_column.titleColor}
        paragraphsFirstColumn={freeTextData.free_text_one_column.paragraphsFirstColumn}
        paragraphsSecondColumn={freeTextData.free_text_one_column.paragraphsSecondColumn}
        paragraphsColor={freeTextData.free_text_one_column.paragraphsColor}
        ctas={freeTextData.free_text_one_column.ctas}
      />
      <br /><br />
      <TakisFreeText
        title={freeTextData.free_text_two_column.title}
        titleColor={freeTextData.free_text_two_column.titleColor}
        paragraphsFirstColumn={freeTextData.free_text_two_column.paragraphsFirstColumn}
        paragraphsSecondColumn={freeTextData.free_text_two_column.paragraphsSecondColumn}
        paragraphsColor={freeTextData.free_text_two_column.paragraphsColor}
        ctas={freeTextData.free_text_two_column.ctas}
      />
      <br /><br />
      <TakisGrid
        title="Takis Rolled"
        items={productsData.product_grid.items}
      />
      <br /><br />

      <h3>Recipe Details Components</h3>
      <br /><br />
      <div className={classes.yellow}>
        <TakisSimpleText
          paragraph={recipeDetailComponents.simpleText1.paragraph}
          variation={recipeDetailComponents.simpleText1.variation}
        />
        <TakisMediaComponent
          description={recipeDetailComponents.media1.description}
          alignImage={recipeDetailComponents.media1.alignImage}
          imageSrc={recipeDetailComponents.media1.imageSrc}
          imageAlt={recipeDetailComponents.media1.imageAlt}
          caption={recipeDetailComponents.media1.caption}
        />
        <TakisMediaComponent
          description={recipeDetailComponents.media2.description}
          alignImage={recipeDetailComponents.media2.alignImage}
          imageSrc={recipeDetailComponents.media2.imageSrc}
          imageAlt={recipeDetailComponents.media2.imageAlt}
        />
        <TakisMediaComponent
          alignImage={recipeDetailComponents.media3.alignImage}
          imageSrc={recipeDetailComponents.media3.imageSrc}
          imageAlt={recipeDetailComponents.media3.imageAlt}
          caption={recipeDetailComponents.media3.caption}
        />
        <TakisSimpleText
          paragraph={recipeDetailComponents.simpleText2.paragraph}
        />
        <TakisSimpleText
          paragraph={recipeDetailComponents.simpleText3.paragraph}
          variation={recipeDetailComponents.simpleText3.variation}
        />
        <TakisSimpleText
          paragraph={recipeDetailComponents.simpleText4.paragraph}
          variation={recipeDetailComponents.simpleText4.variation}
        />
      </div>
      <br /><br />

      <TakisRecipeList
        title={recipesListData.title}
        recipes={recipesListData.recipes}
      />
    </>
  );
};

export default Components;
